__webpack_require__.p = "https://quiz.brandr.legal/";